import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Bars3Icon,
  XMarkIcon,
  HomeIcon,
  BookOpenIcon,
  ArrowUpTrayIcon,
  CalendarDaysIcon,
  ChartBarSquareIcon,
  QuestionMarkCircleIcon,
  ClipboardDocumentListIcon,
  AcademicCapIcon,
} from '@heroicons/react/24/outline';

const TeacherNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { path: '/teachers/dashboard', label: 'Home', icon: HomeIcon },
    { path: '/teachers/dashboard/courses', label: 'Courses', icon: BookOpenIcon },
    { path: '/teachers/dashboard/quizzes/new', label: 'Uploads', icon: ArrowUpTrayIcon },
    { path: '/teachers/dashboard/schedule', label: 'Calendar', icon: CalendarDaysIcon },
    { path: '/teachers/dashboard/performance', label: 'Performance', icon: ChartBarSquareIcon },
    { path: '/teachers/dashboard/past-questions', label: 'Past Questions', icon: QuestionMarkCircleIcon },
    { path: '/teachers/dashboard/quizzes', label: 'Quizzes', icon: ClipboardDocumentListIcon },
 
  ];

  const linkClasses = isActive =>
    `inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-medium transition ${
      isActive
        ? 'bg-emerald-700 text-white shadow-sm ring-1 ring-white/20'
        : 'text-emerald-100 hover:bg-white/10 hover:text-white'
    }`;

  return (
    <nav className="sticky top-0 z-40 border-b border-emerald-700/40 bg-gradient-to-r from-emerald-700 via-teal-700 to-emerald-800 text-white shadow-lg backdrop-blur-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3">
          <NavLink to="/teachers/dashboard" className="flex items-center gap-3 hover:opacity-95">
            <div className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/30">
              <AcademicCapIcon className="h-5 w-5" />
            </div>
            <div>
              <p className="text-sm font-semibold">Teacher Workspace</p>
              <p className="text-xs text-emerald-100">DeBest College</p>
            </div>
          </NavLink>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="rounded-lg p-2 text-emerald-100 hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/40 md:hidden"
          aria-label="Toggle navigation"
        >
          {isOpen ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
        </button>
      </div>

      {/* Desktop menu */}
      <div className="hidden md:flex md:flex-wrap md:gap-2 md:pb-3">
        {menuItems.map((item) => (
          (() => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => linkClasses(isActive)}
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            );
          })()
        ))}
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden ${isOpen ? 'block' : 'hidden'} space-y-2 pb-3`}>
        {menuItems.map((item) => (
          (() => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `${linkClasses(isActive)} flex w-full`}
                onClick={() => setIsOpen(false)}
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            );
          })()
        ))}
      </div>
      </div>
    </nav>
  );
};

export default TeacherNavbar;
